export default __webpack_public_path__ + "static/media/MapMarker.1a23f9b6.png";